import React from 'react';
import loadable from 'react-loadable';

const Loader = props => {
  if (props.error) {
    return <div>Oh no, something went wrong!</div>;
  } else if (props.delay) {
    return (
      <h2 className="uk-flex uk-flex-column uk-flex-middle uk-flex-center uk-background-primary">
        Loading...
      </h2>
    );
  } else {
    return null;
  }
};
export default loadable({
  loader: () => import(/* webpackChunkName: "Pond" */ './Pond'),
  loading: Loader,
  delay: 300,
});



// WEBPACK FOOTER //
// ./src/features/pond/PondLoadable.js